/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Header_DescriptionInputs */

const id_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periksa snapshot build ini dan bandingkan dengan build yang diamati sebelumnya.`)
};

const ms_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periksa syot kilat binaan ini dan bandingkan dengan binaan yang diperhatikan sebelum ini.`)
};

const da_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undersøg dette build-snapshot, og sammenlign det med tidligere observerede builds.`)
};

const de_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untersuche diesen Build-Snapshot und vergleiche ihn mit zuvor beobachteten Builds.`)
};

const en_us2_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspect this build snapshot and compare it with earlier observed builds.`)
};

const es_es2_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta esta compilación y compárala con compilaciones observadas anteriormente.`)
};

const es_mx2_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta esta compilación y compárala con compilaciones observadas anteriormente.`)
};

const fil_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suriin ang snapshot ng build na ito at ihambing ito sa mga naunang naobserbahang build.`)
};

const fr_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examinez cet instantané de build et comparez-le aux builds observés précédemment.`)
};

const it_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esamina questo snapshot della build e confrontalo con le build osservate in precedenza.`)
};

const hu_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vizsgáld meg ezt a build-pillanatképet, és hasonlítsd össze a korábban megfigyelt buildekkel.`)
};

const nl_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk deze build-snapshot en vergelijk deze met eerder waargenomen builds.`)
};

const no_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undersøk dette build-øyeblikksbildet og sammenlign det med tidligere observerte builds.`)
};

const pl_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź ten zrzut buildu i porównaj go z wcześniej zaobserwowanymi buildami.`)
};

const pt_br2_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecione este snapshot do build e compare-o com builds observados anteriormente.`)
};

const pt_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecione esta captura da compilação e compare-a com compilações observadas anteriormente.`)
};

const ro_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspectează acest instantaneu al buildului și compară-l cu buildurile observate anterior.`)
};

const fi_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkastele tätä build-vedosta ja vertaa sitä aiemmin havaittuihin buildeihin.`)
};

const sv_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Granska den här build-ögonblicksbilden och jämför den med tidigare observerade builds.`)
};

const vi_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm tra ảnh chụp build này và so sánh với các build được quan sát trước đó.`)
};

const tr_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu derleme anlık görüntüsünü inceleyin ve daha önce gözlemlenen derlemelerle karşılaştırın.`)
};

const cs_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohlédněte tento snímek buildu a porovnejte ho s dříve zaznamenanými buildy.`)
};

const bg_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прегледайте тази моментна снимка на компилацията и я сравнете с по-рано наблюдавани компилации.`)
};

const ru_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изучите этот снимок сборки и сравните его с предыдущими.`)
};

const uk_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перегляньте цей знімок білду та порівняйте його з білдами, які спостерігалися раніше.`)
};

const ar_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افحص لقطة البناء هذه وقارنها بالبناءات المرصودة سابقًا.`)
};

const hi_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस बिल्ड स्नैपशॉट का निरीक्षण करें और इसकी तुलना पहले देखे गए बिल्ड से करें।`)
};

const th_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตรวจสอบสแนปช็อตบิลด์นี้และเปรียบเทียบกับบิลด์ที่พบก่อนหน้านี้`)
};

const ja_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このビルドスナップショットを確認し、以前に観測されたビルドと比較します。`)
};

const zh_cn2_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看此构建快照，并与之前观察到的构建进行比较。`)
};

const zh_hant1_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檢視此組建快照，並與先前觀察到的組建比較。`)
};

const ko_builds_header_description = /** @type {(inputs: Builds_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 빌드 스냅샷을 확인하고 이전에 관찰된 빌드와 비교합니다.`)
};

/**
* | output |
* | --- |
* | "Inspect this build snapshot and compare it with earlier observed builds." |
*
* @param {Builds_Header_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_header_description = /** @type {((inputs?: Builds_Header_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Header_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_header_description(inputs)
	if (locale === "ms") return ms_builds_header_description(inputs)
	if (locale === "da") return da_builds_header_description(inputs)
	if (locale === "de") return de_builds_header_description(inputs)
	if (locale === "en-US") return en_us2_builds_header_description(inputs)
	if (locale === "es-ES") return es_es2_builds_header_description(inputs)
	if (locale === "es-MX") return es_mx2_builds_header_description(inputs)
	if (locale === "fil") return fil_builds_header_description(inputs)
	if (locale === "fr") return fr_builds_header_description(inputs)
	if (locale === "it") return it_builds_header_description(inputs)
	if (locale === "hu") return hu_builds_header_description(inputs)
	if (locale === "nl") return nl_builds_header_description(inputs)
	if (locale === "no") return no_builds_header_description(inputs)
	if (locale === "pl") return pl_builds_header_description(inputs)
	if (locale === "pt-BR") return pt_br2_builds_header_description(inputs)
	if (locale === "pt") return pt_builds_header_description(inputs)
	if (locale === "ro") return ro_builds_header_description(inputs)
	if (locale === "fi") return fi_builds_header_description(inputs)
	if (locale === "sv") return sv_builds_header_description(inputs)
	if (locale === "vi") return vi_builds_header_description(inputs)
	if (locale === "tr") return tr_builds_header_description(inputs)
	if (locale === "cs") return cs_builds_header_description(inputs)
	if (locale === "bg") return bg_builds_header_description(inputs)
	if (locale === "ru") return ru_builds_header_description(inputs)
	if (locale === "uk") return uk_builds_header_description(inputs)
	if (locale === "ar") return ar_builds_header_description(inputs)
	if (locale === "hi") return hi_builds_header_description(inputs)
	if (locale === "th") return th_builds_header_description(inputs)
	if (locale === "ja") return ja_builds_header_description(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_header_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_header_description(inputs)
	return ko_builds_header_description(inputs)
});
export { builds_header_description as "builds.header.description" }